<template>
  <VNavigationDrawer
    app
    permanent
    fixed
    color="primary"
    left
    width="250"
    mini-variant-width="86"
    class="fixed-menu"
    style="z-index: 100; top: 0; max-height: initial; height: 100%;"
    :class="{'close' : miniVariant}"
    :mini-variant="miniVariant"
  >
    <div v-if="company && company.companyPartnerCode === companyPartnerCodeTypes.ROSTELECOM" class="rt">
      <a href="/" class="logo my-5">
        <img class="rt-full " src="../../assets/img/rt/huntica-rt-menu.svg" alt="">
        <img class="rt-min" src="../../assets/img/rt/rt-min.svg" alt="">
        <img class="hun" src="../../assets/img/logo-min.svg" alt="">
      </a>
    </div>
    <a v-else href="/" class="logo my-5" />

    <MenuItems :mini-variant="miniVariant" />

    <div class="mt-auto pb-5">
      <MenuContacts :open-menu="!miniVariant" />

      <VList dense class="py-0 px-0" dark>
        <MenuNotificationsLink :mini-variant="miniVariant" />
        <MenuSettingsLink :mini-variant="miniVariant" />
        <MenuLogoutLink :mini-variant="miniVariant" />
      </VList>
    </div>

    <div
      class="fixed-menu__toggle"
      :class="{'open' : !miniVariant}"
      @click="miniVariant = !miniVariant"
    />
  </VNavigationDrawer>
</template>

<script>
import useCompany from '@/compositions/useCompany';
import { companyPartnerCodeType } from '@/enums';
import MenuItems from './TheMenuItems.vue';
import MenuContacts from './TheMenuContacts.vue';
import MenuNotificationsLink from './TheMenuNotificationsLink.vue';
import MenuSettingsLink from './TheMenuSettingsLink.vue';
import MenuLogoutLink from './TheMenuLogoutLink.vue';

export default {
  name: 'TheMenuDesktop',
  components: {
    MenuItems, MenuContacts, MenuNotificationsLink, MenuSettingsLink, MenuLogoutLink,
  },
  data() {
    return {
      miniVariant: true,
      companyPartnerCodeTypes: companyPartnerCodeType,
    };
  },
  setup() {
    const { company } = useCompany();

    return {
      company,
    };
  },
};
</script>

<style lang="scss">
  .fixed-menu {
    .v-navigation-drawer__content {
      display: flex;
      flex-direction: column;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 5px;
        background: #f0f0f0;
      }
      &::-webkit-scrollbar-thumb {
        background: #cdcdcd;
      }
    }
    &.close {
      .v-list-item {
        flex-direction: column;
      }
      .menu-contacts {
        display: none;
      }
    }
  }
</style>

<style scoped lang="scss">
  .fixed-menu {
    color: #fff;
    overflow: visible;
    &__toggle {
      position: absolute;
      right: -15px;
      top: 28px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 30px;
      height: 30px;
      cursor: pointer;
      background: #1F85D7;
      border: 3px solid #FFFFFF;
      border-radius: 50%;
      font-size: 18px;
      &:before, &:after {
        content: '';
        display: block;
        position: relative;
        width: 10px;
        height: 2px;
        background: #fff;
        border-radius: 2px;
        margin: 2px 0;
      }
      &.open{
        &:before, &:after{
          width: 16px;
          margin: -1px 0;
        }
        &:before{
          transform: rotate(-45deg);
        }
        &:after{
          transform: rotate(45deg);
        }
      }
    }
    .theme--dark.v-list {
      background: transparent;
    }
  }

  .logo {
    display: block;
    text-align: center;
    width: 11.25rem;
    height: 2rem;
    min-height: 2rem;
    background: url(../../assets/img/logo.svg) no-repeat left center;
    background-size: contain;
    margin-left: 28px;
    .rt-min {
      display: none;
    }
    .hun {
      display: none;
    }
  }
  .rt .logo {
    width: 11.4375rem;
    height: 4.25rem;
    background-image: none;
    img {
      max-width: 100%;
    }
  }

  .close {
    .logo {
      width: 42px;
      height: 36px;
      margin-left: 1.9375rem;
      background-image: url(../../assets/img/logo-min.svg);
      position: relative;
      .rt-full {
        display: none;
      }
      .hun {
        display: block;
        height: 100%;
        animation: logo-hun 30s infinite linear;
      }
      .rt-min {
        display: block;
        position: absolute;
        left: 3px;
        top: 2px;
        opacity: 0;
        animation: logo-rt 30s infinite linear;
      }
    }
    .rt .logo {
      background-image: none;
    }
  }
  @keyframes logo-hun {
    from {
      opacity: 0;
    }
    1% {
      opacity: 1;
    }
    48% {
      opacity: 1;
    }
    49% {
      opacity: 0;
    }
    to {
      opacity: 0;
    }
  }
  @keyframes logo-rt {
    from {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    51% {
      opacity: 1;
    }
    98% {
      opacity: 1;
    }
    99% {
      opacity: 0;
    }
    to {
      opacity: 0;
    }
  }

</style>
